let current = null;
export function configureAuth(config) {
    current = { scope: "openid profile email", provider: "keycloak", ...config };
}
export function getAuthConfig() {
    if (!current) {
        throw new Error("@healthos/auth: configureAuth() must be called before useAuth/AuthProvider. Call it from your app entry with values loaded from your runtime env.");
    }
    return current;
}
export function isAuthConfigured() {
    return current !== null;
}
//# sourceMappingURL=config.js.map